import { ContentModuleStyle } from '@silvertours/common-landingpages-view';

export type BackgroundStyle =
  | 'default'
  | 'gray'
  | 'green'
  | 'greenAlt'
  | 'mint'
  | 'orange'
  | 'orangeAlt'
  | 'brand'
  | 'mintAlt';

export type HasBackgroundStyle = {
  backgroundStyle?: BackgroundStyle;
};

export const selectBackgroundStyle = (style: ContentModuleStyle) => style;
